/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Translation_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Delete this translation event" |
*
* @param {Event_Delete_Translation_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_translation_aria_label = /** @type {((inputs?: Event_Delete_Translation_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Translation_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer cet evenement de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Übersetzungsereignis löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina questo evento di traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить это событие перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar este evento de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除此翻译事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この翻訳イベントを削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस अनुवाद इवेंट को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir este evento de tradução")
	return /** @type {LocalizedString} */ ("Delete this translation event")
});